import { MediaData } from 'components/MediaViewer'
import { AppPreviewActions } from '.'
import { InterpolationListProps } from '..'
import { TextListGroupValue } from 'particles/TextInputs/TextList/Group'

export interface UpdateIgStoryNonUgcStep1DataPayload {
    taskTitle?: string
    stepTitle?: string
    submissionRequirementDescription?: string
    examplePhotos?: MediaData[]
    mediaDos?: string
    mediaDonts?: string
    captionHashtags?: (TextListGroupValue | undefined)[]
    profileTags?: (TextListGroupValue | undefined)[]
}

interface UpdateIgStoryNonUgcInterpolationListDataPayload {
    mediaDos: InterpolationListProps
}

export const updateIgStoryNonUgcStep1Data = (payload: UpdateIgStoryNonUgcStep1DataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_IG_STORY_NON_UGC_STEP1_DATA,
})

export const updateIgStoryNonUgcInterpolationListData = (payload: UpdateIgStoryNonUgcInterpolationListDataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_IG_STORY_NON_UGC_PLACEHOLDER_DATA,
})
